import script from "./UiProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./UiProgress.vue?vue&type=script&setup=true&lang=js"

import "./UiProgress.vue?vue&type=style&index=0&id=65db4a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65db4a66"]])

export default __exports__